import React, {useState, useEffect, useContext, useCallback, useRef} from 'react';
import GridLayout from 'react-grid-layout';
import '../css/GUIInstrumentGrid.css';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import GUIInstrumentRow from "../gridcomponents/guiinstrumentrow/GUIInstrumentRow";
import Button from '@mui/material/Button';
import SearchIcon from '@mui/icons-material/Search';  // Import Search Icon
import {fetchGUIInstrumentsByTabID} from '../../services/GUIInstrumentService';
import {updateTickerSubscriptionWithKite} from "../../services/apiService";
import {DataContext} from "../../contexts/DataContext";  // You need to implement this function
import {handleSearch} from '../../services/apiService';  // Adjust the path if necessary
import {updateGUIInstrumentsToBackend} from '../../services/apiService'; // Import the new API function
import CustomArrowIcon from '../gridcomponents/components/CustomArrowIcon';
import ActionButtons from "../gridcomponents/components/ActionButtons";
import {
    handleAddPosition,
    handleAddToOldGrid,
    handleDeleteFromOldGrid,
    handleSortToggle
} from "../gridcomponents/util/GridOperations";
import {useStateUpdatePermission} from "../../contexts/StateUpdateContext";
import ExchangeButtons from '../gridcomponents/components/ExchangeButtons';
import {handleShowDetails} from "../gridcomponents/guiinstrumentrow/MoreDetails/MoreDetailsOperations";
import {handleShowAnnouncements} from "@marketwatch/gridcomponents/util/GridOperations";
import {TickProvider} from "../../contexts/TickContext";
import ChartDrawer from "../../charts/ChartDrawer";
import {AnnouncementProvider} from "@dashboard/contexts/ExchangeAnnContext"; // Add this import
import { InstrumentRowContext } from "@dashboard/contexts/InstrumentRowContext";
import {RowSelectionProvider} from "@portfolio/context/RowSelectionContextProvider";
import {normalizeSymbol} from "@dashboard/shared/pfSymbolsRef";

const GUIInstrumentGridID = ({tabID, setSelectedToken,setSelectedChartSymbol }) => {
    const [GUIInstruments, setGUIInstruments] = useState([]);
    const [layouts, setLayouts] = useState([]);
    const [newRowAdded, setNewRowAdded] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [filteredInstruments, setFilteredInstruments] = useState([]);
    const {allInstrumentsList} = useContext(DataContext);
    const [newGridVisible, setNewGridVisible] = useState(false); // State to control new grid visibility
    const [sortDirection, setSortDirection] = useState('flat'); // State for sort direction
    const [draggingItem, setDraggingItem] = useState(null);
    const emptyGridItemIndexRef = useRef(null);  // Replace the state with a ref
    const {canUpdateState, setCanUpdateState} = useStateUpdatePermission(); // Access state and setter
    const [layoutKey, setLayoutKey] = useState(0);  // State to store the key for GridLayout
    const gridLayoutRef = useRef(null);
    const gridItemRefs = useRef([]); // Array of refs for each grid-item
    const moreDetailsLayoutRef = useRef(null); // Define the ref in a React component
    const rowHeightGridLayout = 45;
    const {initialSymbolToBSEAnnouncementsMap, initialSymbolToNSEAnnouncementsMap} = useContext(DataContext);
    const lastSelectedSymbolRef = useRef(null);

    const handleShowChart = (token,symbol) => {
        setSelectedToken(token); // Use global controller
        setSelectedChartSymbol(symbol);
    };

    // Handle drag start
    let startX, startY;
    const handleDragStart = (layout, oldItem, newItem, placeholder, e, element) => {
        setDraggingItem(oldItem);  // Track the dragged item
        setCanUpdateState(true);
        /*console.log("Clicked item:", oldItem);
        console.log("Mouse Y Position:", e.clientY);*/
        const gridTop = gridLayoutRef.current.getBoundingClientRect().top;
        /*console.log("Grid Top Y Position:", gridTop);*/
    };

    /*useEffect(() => {
        console.log("allInstrumentsList:", allInstrumentsList);
    }, [allInstrumentsList]);
*/
    const handleDrag = (layout, oldItem, newItem, placeholder, e, element) => {
        console.log("handleDrag");
        if (!gridLayoutRef.current) {
            console.error("Grid container ref not available.");
            return;
        }
        // Get the bounding box of the grid container
        const gridTop = gridLayoutRef.current.getBoundingClientRect().top;
        /*console.log("gridTop: ", gridTop);*/

        // Calculate hover index based on the current mouse position relative to the grid
        const relativeY = e.clientY - gridTop;  // Adjust clientY to be relative to the grid's top
        /*console.log("e.clientY: ", e.clientY);
        console.log("relativeY: ", relativeY);*/

        // Assume row height is 40px (adjust this if needed based on your grid's row height)
        const hoverIndex = Math.floor(relativeY / 40);
        /*console.log("hoverIndex: ", hoverIndex);*/
        console.log("emptyGridItemIndexRef.current: ", emptyGridItemIndexRef.current);

        // Only update the layout if the hoverIndex has changed
        if (hoverIndex !== emptyGridItemIndexRef.current) {
            emptyGridItemIndexRef.current = hoverIndex;  // Update the ref, no re-render
            console.log("emptyGridItemIndexRef.current set to: ", emptyGridItemIndexRef.current);

            // Update the layout immediately based on the new hover index
            setLayouts((prevLayouts) => prevLayouts.map((layout) => ({
                ...layout,
                y: layout.y >= hoverIndex ? layout.y + 1 : layout.y
            })));
            /*
                        setLayoutKey(prevKey => prevKey + 1);   // This forces GridLayout to re-render
            */
        }
    };


    const handleDragStop = (layout, oldItem, newItem) => {
        setLayouts(layout);      // Update the layout
        /*console.log("layout: ",layout);*/

        const draggedInstrumentToken = newItem.i.split(`${tabID}-`)[1];  // Extract the instrumentToken from the layout ID
        const draggedInstrument = GUIInstruments.find(instrument => {
            /*console.log("Checking instrument:", instrument);  // Logs each instrument being checked
            console.log("instrumentToken:", instrument.instrumentToken);  // Logs each instrument being checked
            console.log("draggedInstrumentToken:", draggedInstrumentToken);  // Logs each instrument being checked*/
            return Number(instrument.instrumentToken) === Number(draggedInstrumentToken);  // Ensure both are numbers
        });
        /*console.log("draggedInstrument:", draggedInstrument);  // Logs each instrument being checked*/

        // Get the original and new sequence numbers
        const originalSequenceNumber = draggedInstrument.sequenceNumber;
        const newSequenceNumber = newItem.y;  // Use y position as the new sequence number

        /*console.log("Dragged Instrument:", draggedInstrument);
        console.log("Original Sequence Number:", originalSequenceNumber);
        console.log("New Sequence Number:", newSequenceNumber);
*/
        // Update the sequence numbers of the other instruments
        const updatedInstruments = GUIInstruments.map(instrument => {
            if (instrument.instrumentToken === Number(draggedInstrumentToken)) {
                // Update the dragged item's sequence number
                return {
                    ...instrument,
                    sequenceNumber: newSequenceNumber,
                };
            } else if (
                originalSequenceNumber < newSequenceNumber &&
                instrument.sequenceNumber > originalSequenceNumber &&
                instrument.sequenceNumber <= newSequenceNumber
            ) {
                // If the dragged item moved down, decrease the sequence number of items between the old and new position
                return {
                    ...instrument,
                    sequenceNumber: instrument.sequenceNumber - 1,
                };
            } else if (
                originalSequenceNumber > newSequenceNumber &&
                instrument.sequenceNumber >= newSequenceNumber &&
                instrument.sequenceNumber < originalSequenceNumber
            ) {
                // If the dragged item moved up, increase the sequence number of items between the old and new position
                return {
                    ...instrument,
                    sequenceNumber: instrument.sequenceNumber + 1,
                };
            }

            return instrument;
        });

        // Update the state with the new instruments
        setGUIInstruments(updatedInstruments);
        /*console.log("Updated Instruments:", updatedInstruments);*/

        // Call the backend to update the sequence numbers on the server
        updateGUIInstrumentsToBackend(updatedInstruments, tabID);
        updateTickerSubscriptionWithKite(updatedInstruments, tabID);

    };

    useEffect(() => {
        handleSearch(searchQuery, allInstrumentsList, setFilteredInstruments);
    }, [searchQuery]);

    useEffect(() => {
        /*console.log('newGridVisible',newGridVisible);*/
        setNewGridVisible(filteredInstruments.length > 0);
        /*console.log('newGridVisible',newGridVisible);*/
    }, [filteredInstruments]);

    const handleEscape = (event) => {
        if (event.key === 'Escape') {
            setNewGridVisible(false);
            setSearchQuery('');
        }
    };

    useEffect(() => {
        if (newGridVisible) {
            document.addEventListener('keydown', handleEscape);
        } else {
            document.removeEventListener('keydown', handleEscape);
        }
        return () => {
            document.removeEventListener('keydown', handleEscape);
        };
    }, [newGridVisible]);


    // Function to update price difference for each instrument
    const handlePriceDifferenceUpdate = (instrumentToken, priceDifference) => {
        /*if (canUpdateState) {
            setGUIInstruments((prevInstruments) =>
                prevInstruments.map(instrument => {
                    if (instrument.instrumentToken === instrumentToken) {
                        return {...instrument, priceDifferencePercentage: priceDifference};
                    }
                    return instrument;
                })
            );
        }*/
    }

    useEffect(() => {
        fetchGUIInstrumentsByTabID(tabID).then(data => {
            setGUIInstruments(data);

            // Use the sequenceNumber field for the y value instead of the index
            const initialLayouts = data.map((GUIInstrument) => ({
                i: `${tabID}-${GUIInstrument.instrumentToken}`,
                x: 0,
                y: GUIInstrument.sequenceNumber,  // Use sequenceNumber for y value
                w: 12,
                h: 1,
            }));

            setLayouts(initialLayouts);
            /*console.log('Initial layouts:', initialLayouts);*/

            //handleSortToggle(sortDirection, setSortDirection, data, setGUIInstruments, setLayouts, tabID);

            updateTickerSubscriptionWithKite(data, tabID)
                .then(response => {
                    // console.log('Subscription with Kite successful:', response.data);
                })
                .catch(error => {
                    console.error('Error in subscription with Kite:', error);
                });
        });
    }, [tabID]);

    // Dynamically calculate rowHeight and total grid height
    const rowHeightNewGridLayout = 36; // Assume each row is 40px high
    const calculateGridHeight = () => {
        const itemCount = filteredInstruments.length;
        return itemCount > 0 ? (itemCount) * rowHeightNewGridLayout : rowHeightNewGridLayout;  // Set height based on the number of items
    };
    const onLayoutChange = (newLayout) => {
        setLayouts(newLayout);
        console.log('New Layout:', newLayout);
    };

/*
    const handleShowAnnouncements = (instrumentToken) => {
        setGUIInstruments(prev =>
            prev.map(instr =>
                instr.instrumentToken === instrumentToken
                    ? { ...instr, forceShowAnnouncements: true }
                    : instr
            )
        );
    };
*/

    /*useEffect(() => {
        console.log("Rendered Layouts: ", layouts);
    }, [layouts]);*/
    /*console.log("layouts: ", layouts); // Log before JSX return*/
    return (
        <div className="resizable-container">
            <div className="overlaping-grid-container">
                <div className="search-input-container">
                    <div className="search-button-1">
                        <Button
                            variant="contained"
                            color="default">
                            <SearchIcon/>
                        </Button>
                    </div>
                    <input
                        type="text"
                        placeholder='Search trading token'
                        value={searchQuery}
                        onChange={(e) => {
                            const query = e.target.value;
                            /*console.log('setting SearchQuery to: ', query);*/
                            setSearchQuery(query);
                        }}
                        className="search-input-box"
                    />
                    <div className="sort-button-arrow">
                        <Button
                            onClick={() => handleSortToggle(sortDirection, setSortDirection, GUIInstruments, setGUIInstruments, setLayouts,tabID)}
                            variant="contained" color="default"
                            sx={{
                                padding: 0,                // Remove extra padding around the button content
                                margin: 0,                 // Ensure no extra margins
                                marginRight: '7px',
                                fontSize: '32px',
                                display: 'flex',            // Flexbox to align icon center
                                alignItems: 'center',       // Vertically center icon
                                justifyContent: 'center',   // Horizontally center icon
                                color: '#B0B0B0',          // Lighter grey color
                                border: 'none',
                                boxShadow: 'none',
                                transform: 'translateY(3px)',  // Adjust this value to move the arrow down
                                '&:hover': {
                                    border: 'none',        // Disable border on hover
                                    boxShadow: 'none',     // Disable shadow on hover
                                    backgroundColor: 'transparent',  // Optionally make background transparent
                                },
                                '&:focus': {
                                    border: 'none',        // Disable border on focus
                                    boxShadow: 'none',     // Disable shadow on focus
                                },
                                '&:active': {
                                    border: 'none',        // Disable border on active
                                    boxShadow: 'none',     // Disable shadow on active
                                }
                            }}>
                            {sortDirection === 'asc' ? (
                                <CustomArrowIcon direction="up"/>
                            ) : sortDirection === 'desc' ? (
                                <CustomArrowIcon direction="down"/>
                            ) : (
                                <CustomArrowIcon direction="flat"/>  // Display flat arrow for no sorting
                            )}
                        </Button>
                    </div>
                </div>
                {newGridVisible && (
                    <GridLayout
                        className="new-grid-layout"
                        cols={1}
                        rowHeight={rowHeightNewGridLayout}  // Set the row height
                        width={100}
                        isResizable={false}
                        isDraggable={false}
                        /*compactType={null}*/
                        preventCollision={true}
                        margin={[0, 0]}  // Set margin to 0 between items
                        style={{height: `${calculateGridHeight()}px`}}  // Set dynamic height based on number of items
                    >
                        {filteredInstruments.map((instrument, index) => {
                            // Check if the instrument is in the GUIInstruments state
                            const isExistingInGrid = GUIInstruments.some(guiInstrument => guiInstrument.instrumentToken === instrument.instrumentToken);
                            return (
                                <div
                                    key={index}
                                    className="new-grid-item"
                                    onClick={!isExistingInGrid ? () => handleAddToOldGrid(instrument, 0, layouts, setLayouts, tabID, setGUIInstruments) : undefined}
                                    style={{
                                        cursor: 'pointer',
                                        backgroundColor: isExistingInGrid ? '#E0E0E0' : 'transparent'  // Grey background if it exists in the grid
                                    }}
                                >
                                    <div style={{display: 'flex', alignItems: 'center'}}>
                                    <span style={{display: 'inline-block', width: '20px'}}>
                                         {isExistingInGrid && <span>✔</span>}
                                    </span>
                                        <span
                                            style={{fontSize: '13px', width: '110px'}}>{instrument.tradingsymbol}</span>
                                        <span style={{
                                            marginLeft: '20px',
                                            fontSize: '10px'
                                        }}>{instrument.name}</span>
                                    </div>
                                    <ExchangeButtons exchange={instrument.exchange}/>
                                </div>
                            );
                        })}
                    </GridLayout>
                )}
            </div>

            <RowSelectionProvider
                stocks={GUIInstruments}
                lastSelectedSymbolRef={lastSelectedSymbolRef}
                rowHeightGridLayout={rowHeightGridLayout}
            >
            {/* Old Grid Layout */}
            <div ref={gridLayoutRef} className="grid-layout-wrapper">
                <GridLayout
                    className="grid-layout"
                    layout={layouts}  // Layout prop controlling item positions
                    cols={1}
                    rowHeight={rowHeightGridLayout}
                    width={400}
                    isResizable={false}
                    isDraggable={true}
                    margin={[0, 0]}
                    containerPadding={[0, 0]}
                    onDragStop={handleDragStop}  // Update layout on drop
                    draggableCancel="
                        .mw-symbol_n_exchange,
                        .actions,
                        .actions *,
                        .MuiInputBase-root,
                        .MuiFormControl-root,
                        .pva-dialog-content,
                        .MuiDialog-root,
                        .MuiPaper-root
                    ">
                    {/* Render items based on the layout array to maintain the order */}
                    {/*const layouts = layouts.sort((a, b) => a.y - b.y);*/}
                    {/*{(() => {
                    console.log("layouts: ", layouts);
                    return null; // Since you can't just use `console.log` alone in JSX, return null if you're not rendering anything.
                })()}*/}
                    {layouts
                        .sort((a, b) => a.y - b.y)
                        .map((layout, index) => {
                            /*console.log("layout index:",index);*/
                            /*console.log("layout.i:",layout.i);*/
                            /*console.log("GUIInstruments",GUIInstruments);*/
                            const instrument = GUIInstruments.find(
                                (instrument) => `${tabID}-${instrument.instrumentToken}` === layout.i
                            );
                            /*const instrument = GUIInstruments.find(
                                (instrument) => `${instrument.sequenceNumber}` === layout.y
                            );*/
                            return (
                                <div
                                    key={layout.i}
                                    className="grid-item"
                                    /*ref={(el) => {
                                        // Check if the ref exists in the array, or create a new entry.
                                        console.log("el: ",el," gridItemRefs: ",gridItemRefs," gridItemRefs.current: ",gridItemRefs.current);
                                        if (el && !gridItemRefs.current[index]) {
                                            gridItemRefs.current[index] = el;
                                            console.log(`Assigned ref for grid item at index ${index}:`, el);  // Log the ref assignment
                                        }
                                    }}*/
                                >
                                    {/*{console.log("uniqueId:", layout.i)}  */}
                                    {instrument ? (
                                        <InstrumentRowContext.Provider
                                            value={{
                                                uniqueId: layout.i,
                                                GUIInstrument: instrument,
                                                setGUIInstruments: setGUIInstruments,
                                                setLayouts,
                                                tabID,
                                                layouts,
                                                index,
                                                layoutIndex: index,
                                                ROW_HEIGHT: rowHeightGridLayout
                                            }}
                                        >
                                            <AnnouncementProvider
                                                symbol={instrument.tradingsymbol}
                                                initialBSE={initialSymbolToBSEAnnouncementsMap[normalizeSymbol(instrument.tradingsymbol)] || []}
                                                initialNSE={initialSymbolToNSEAnnouncementsMap[normalizeSymbol(instrument.tradingsymbol)] || []}
                                            >
                                        <GUIInstrumentRow
                                            /*onPriceDifferenceUpdate={handlePriceDifferenceUpdate} // Pass the callback*/
                                            onShowChart={() => handleShowChart(instrument.instrumentToken,instrument.tradingsymbol)}
                                        />
                                        </AnnouncementProvider>
                                        </InstrumentRowContext.Provider>
                                    ) : (
                                        <div>No Instrument Found</div>
                                    )}
                                </div>
                            );
                        })}
                </GridLayout>
            </div>
                </RowSelectionProvider>
        </div>
    );
};

export default GUIInstrumentGridID;
